export default __webpack_public_path__ + "static/media/adminIcon.9216f193.png";